import React from 'react';
import PropTypes from 'prop-types';

import './FormSection.sass';

export default function FormSection({title, children}) {
  return (
    <div className="form-section">
      {title && <div className="form-section__title">{title}</div>}

      {children}
    </div>
  );
}

FormSection.propTypes = {
  title: PropTypes.node
};



// WEBPACK FOOTER //
// ./components/fields/formSection/FormSection.js